import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { errorResponseSchema, successResponseSchema } from '../schemas/common.schemas';

const c = initContract();

export const publicContract = c.router({
  identify: {
    method: 'POST',
    path: '/public/identify',
    body: z.object({
      userId: z.string().min(1),
      userData: z.record(z.unknown()).optional(),
    }),
    responses: {
      200: successResponseSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Identify user for persistent memory (frontend SDK)',
  },
});
